import React, { useState } from "react";

import { apiURL } from "../../api/index";

function PostModal(props) {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState("");
  const [isPostAddedSuccessfully, setIsPostAddedSuccessfully] = useState(false);
  const [message, setMessage] = useState("");

  const createPost = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("image", image);
      formData.append("description", description);
      const res = await fetch(`${apiURL}/createpost`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      console.log(data);

      if (data.message === "Post Added") {
        setMessage("The Post Has Been Added Successfully!");
        setIsPostAddedSuccessfully(true);
        setTimeout(() => {
          props.closePostModal();
        }, 2000);

        setTitle("");
        setImage(null);
        setDescription("");
      } else if (data.message === "Invalid Details") {
        setMessage("Invalid Details OR File Type Error!");
        setIsPostAddedSuccessfully(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updatePost = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("image", image);
      formData.append("description", description);
      const res = await fetch(`${apiURL}/updatepost/${props.postId}`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      console.log(data);

      if (data.message === "Post Updated") {
        setMessage("The Post Has Been Updated Successfully!");
        setIsPostAddedSuccessfully(true);
        setTimeout(() => {
          props.closePostModal();
        }, 2000);

        setTitle("");
        setImage(null);
        setDescription("");
      } else {
        setMessage("Invalid Details OR File Type Error!");
        setIsPostAddedSuccessfully(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={
          isPostAddedSuccessfully
            ? "bg-green-600 text-white font-primary text-center"
            : "bg-amber-600 text-white font-primary text-center"
        }
      >
        {message}
      </div>
      <div className="absolute w-[100%] h-[100vh] bg-white bg-opacity-[0.6] justify-center items-center flex">
        <form
          encType="multipart/form-data"
          className="flex flex-col w-96 h-[60vh] mx-auto justify-center items-left p-5 bg-primary text-white rounded-sm"
        >
          <input
            onChange={(e) => setTitle(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            type="text"
            placeholder="Post Title..."
            name="title"
          />

          <input
            onChange={(e) => setImage(e.target.files[0])}
            className="my-2 p-2 outline-none"
            type="file"
            name="image"
          />

          <textarea
            onChange={(e) => setDescription(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            style={{ resize: "vertical" }}
            placeholder="Post Description..."
            name="description"
          />

          {props.operation === "create" ? (
            <button
              className="bg-secondary py-2 mt-2"
              onClick={(e) => createPost(e)}
            >
              Create
            </button>
          ) : (
            <button
              className="bg-secondary py-2 mt-2"
              onClick={(e) => updatePost(e)}
            >
              Update
            </button>
          )}
          <button
            type="submit"
            className="bg-red-600 py-2 mt-2"
            onClick={props.closePostModal}
          >
            Cancel
          </button>
        </form>
      </div>
    </>
  );
}

export default PostModal;
